import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import DatePicker from 'react-datepicker';
import { Redirect } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import {
    Alert,
    Button,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table,
} from 'reactstrap';
import ImageChooserMultiple from 'src/components/imageChooser/ImageChooserMultiple';
import NetworkOverlay from 'src/components/networkOverlay/NetworkOverlay';
import { TR } from 'src/TextRes';
import {
    ApiCourseDelete,
    ApiCourseDuplicate,
    ApiCourseLoad,
    ApiCourseProvidersLoadmine,
    ApiCourseSave,
    Appointment,
    BookingOption,
    Course,
    CoursesProviderLoadMineResult,
    Image,
    Lecturer,
    Location,
    ServerResponse,
    UploadImage,
    ValidationError,
} from '../../api';
import Calendar from '../../components/calendar/Calendar';
import CPCourseBaseData from '../../components/cpCoursesTableBox/CPCourseBaseData';
import CPCourseBaseDataTags from '../../components/cpCoursesTableBox/CPCourseBaseDataTags';
import CPHeaderLoggedIn from '../../components/cpHeaderLoggedIn/CPHeaderLoggedIn';
import ErrorBox from '../../components/errorBox/ErrorBox';
import FAIcon from '../../components/fAIcon/FAIcon';
import Footer from '../../components/footer/Footer';
import './CPCourse.css';

interface Props {
    match: { params: { id: string } };
}

interface State {
    calendarSelected: moment.Moment[];
    calendarIndex?: number;
    calendarType?: string;
    courseID: string;
    courseTypeChoice?: string;
    defaultParticipants: number;
    redirectToList: boolean;
    loading: boolean;
    modalDuplicateOpen: boolean;
    modalDeleteOpen: boolean;
    modalCannotDeleteOpen: boolean;
    course?: Course;
    courseOrigin?: Course;
    possibleLecturers?: Lecturer[];
    possibleLocations?: Location[];
    saved: boolean;
    showCalendar: boolean;
    serverResponse?: ServerResponse;
    uploadImages: UploadImage[];
    anyChanges: boolean;
    originalPublished: boolean;
}

// registerLocale('de', de);

export default class CPCourse extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            calendarSelected: [],
            course: undefined,
            courseID: '',
            courseOrigin: undefined,
            defaultParticipants: 5,
            redirectToList: false,
            loading: true,
            modalDuplicateOpen: false,
            modalDeleteOpen: false,
            modalCannotDeleteOpen: false,
            saved: false,
            serverResponse: undefined,
            showCalendar: false,
            uploadImages: [],
            anyChanges: false,
            originalPublished: false,
        };
    }

    public componentDidMount() {
        this.setState({ courseID: this.props.match.params.id }, this.loadLecturersAndLocations);
    }

    public render() {
        if (!this.state.course && this.state.loading) {
            return null;
        } else if (!this.state.course) {
            return <div style={{ padding: '20px' }}>404 - Kurs kann nicht geladen werden</div>;
        }
        if (this.state.saved || this.state.redirectToList) {
            return <Redirect to="/cpcourses" />;
        }

        const { courseTypeChoice } = this.state;

        const ctype = this.state.course ? this.state.course.Type : '';

        const titleOk = !!this.state.course.Title;
        const descriptionOk = !!this.state.course.Description;
        const timesOk = !!this.state.course.TimeDetails;
        const appointmentsOk =
            this.state.course.Type === 'ondemand' ||
            this.state.course.Type === 'selflearn' ||
            (this.state.course.Type === 'new' &&
                (this.state.courseTypeChoice === 'ondemand' || this.state.courseTypeChoice === 'selflearn'))
                ? true
                : this.state.course.Appointments.length > 0;
        const bookingOptionsOk = this.state.course.BookingOptions[0].Price > 0;
        const categoryOk = this.state.course.Categories.length > 0;
        const levelsOk = this.state.course.Levels.length > 0;
        const techniquesOk = this.state.course.Techniques.length > 0;
        const topicsOk = this.state.course.Topics.length > 0;
        const videoURLOk =
            this.state.course.VideoURL === '' ||
            this.state.course.VideoURL.substr(0, 24) === 'https://www.youtube.com/' ||
            this.state.course.VideoURL.substr(0, 23) === 'http://www.youtube.com/' ||
            this.state.course.VideoURL.substr(0, 16) === 'http://youtu.be/' ||
            this.state.course.VideoURL.substr(0, 17) === 'https://youtu.be/' ||
            this.state.course.VideoURL.substr(0, 18) === 'https://vimeo.com/' ||
            this.state.course.VideoURL.substr(0, 17) === 'http://vimeo.com/';

        const lecturerOK = this.state.course.LecturerID !== 0;
        const locationOK = this.state.course.LocationID !== 0;

        const anyProblems =
            !titleOk ||
            !videoURLOk ||
            !descriptionOk ||
            !timesOk ||
            !appointmentsOk ||
            !bookingOptionsOk ||
            !lecturerOK ||
            !categoryOk ||
            !levelsOk ||
            !techniquesOk ||
            !topicsOk ||
            !locationOK;

        const translations: Record<string, string> = {
            continuous: TR.cPCourse_continuous,
            ondemand: TR.cPCourse_on_demand,
            selflearn: TR.cPCourse_self_learn,
            set: TR.cPCourse_set,
            single: TR.cPCourse_single,
        };

        return (
            <NetworkOverlay
                loading={this.state.loading}
                serverResponse={this.state.serverResponse}
                forceLoading={this.state.loading}
            >
                <CPHeaderLoggedIn />
                <Container id="courseView">
                    <Row>
                        <Col md={12}>
                            <ErrorBox serverResponse={this.state.serverResponse} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <h3>{TR.cPCourse_course_details}</h3>
                        </Col>
                        <Col md={9} className="btnRight">
                            <Button className="mr-1" onClick={this.toggleModalDelete}>
                                {TR.cPCourse_delete_course}
                            </Button>
                            <Button onClick={this.canDuplicate}>{TR.cPCourse_duplicate}</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={9}>
                            <FormGroup>
                                <Label htmlFor="Title" className={this.errorClass('Title')}>
                                    {TR.cPCourse_course_title}
                                </Label>
                                <Input
                                    type="text"
                                    id="Title"
                                    onChange={this.inputHandler}
                                    value={this.state.course.Title}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label htmlFor="RefNo" className={this.errorClass('RefNo')}>
                                    {TR.cPCourse_course_id}
                                </Label>
                                <Input
                                    type="text"
                                    id="RefNo"
                                    onChange={this.inputHandler}
                                    value={this.state.course.RefNo}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label htmlFor="Description" className={this.errorClass('Description')}>
                                    {TR.cPCourse_description}
                                </Label>
                                <TextareaAutosize
                                    style={{
                                        maxHeight: 500,
                                        minHeight: 100,
                                        whiteSpace: 'pre-line',
                                        width: '100%',
                                    }}
                                    name={'description'}
                                    id="Description"
                                    value={this.state.course.Description}
                                    onChange={this.inputHandler}
                                />
                                <span className="fieldHint">{TR.cPCourse_description_help}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label htmlFor="TimeDetails" className={this.errorClass('TimeDetails')}>
                                    {TR.cPCourse_times}
                                </Label>
                                <TextareaAutosize
                                    style={{
                                        maxHeight: 200,
                                        minHeight: 100,
                                        whiteSpace: 'pre-line',
                                        width: '100%',
                                    }}
                                    name={'timeDetails'}
                                    id="TimeDetails"
                                    value={this.state.course.TimeDetails}
                                    onChange={this.inputHandler}
                                />
                                <span className="fieldHint">{TR.cPCourse_time_help}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label htmlFor="MaterialDetails" className={this.errorClass('MaterialDetails')}>
                                    {TR.cPCourse_material}
                                </Label>
                                <TextareaAutosize
                                    style={{
                                        maxHeight: 200,
                                        minHeight: 100,
                                        whiteSpace: 'pre-line',
                                        width: '100%',
                                    }}
                                    name={'material'}
                                    id="MaterialDetails"
                                    value={this.state.course.MaterialDetails}
                                    onChange={this.inputHandler}
                                />
                                <span className="fieldHint">{TR.cPCourse_material_help}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor="AccomodationDetails" className={this.errorClass('AccomodationDetails')}>
                                    {TR.cPCourse_accomodation}
                                </Label>
                                <TextareaAutosize
                                    style={{
                                        maxHeight: 200,
                                        minHeight: 100,
                                        whiteSpace: 'pre-line',
                                        width: '100%',
                                    }}
                                    name={'accomodationDetails'}
                                    id="AccomodationDetails"
                                    value={this.state.course.AccomodationDetails}
                                    onChange={this.inputHandler}
                                />
                                <span className="fieldHint">{TR.cPCourse_accomodation_help}</span>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor="CateringDetails" className={this.errorClass('CateringDetails')}>
                                    {TR.cPCourse_catering}
                                </Label>
                                <TextareaAutosize
                                    style={{
                                        maxHeight: 200,
                                        minHeight: 100,
                                        whiteSpace: 'pre-line',
                                        width: '100%',
                                    }}
                                    name={'cateringDetails'}
                                    id="CateringDetails"
                                    value={this.state.course.CateringDetails}
                                    onChange={this.inputHandler}
                                />
                                <span className="fieldHint">{TR.cPCourse_catering_help}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor="Lecturers" className={this.errorClass('Lecturers')}>
                                    {TR.cPCourse_lecturer}
                                </Label>
                                <Input
                                    type="select"
                                    name="Lecturers"
                                    id="Lecturers"
                                    value={this.state.course!.LecturerID}
                                    onChange={(e) => {
                                        this.changeLecturer(parseInt(e.currentTarget.value, 10));
                                    }}
                                >
                                    <option value={0}>{TR.cPCourse_please_choose}</option>
                                    {this.state.possibleLecturers &&
                                        this.state.possibleLecturers!.map((l: Lecturer) => {
                                            return (
                                                <option key={l.ID} value={l.ID}>
                                                    {l.FirstName + ' ' + l.LastName}
                                                </option>
                                            );
                                        })}
                                </Input>
                                <span className="fieldHint">{TR.cPCourse_lecturer_help}</span>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor="Locations" className={this.errorClass('Locations')}>
                                    {TR.cPCourse_location}
                                </Label>
                                <Input
                                    type="select"
                                    name="Locations"
                                    id="Locations"
                                    value={this.state.course!.LocationID}
                                    onChange={(e) => {
                                        this.changeLocation(parseInt(e.currentTarget.value, 10));
                                    }}
                                >
                                    <option value={0}>{TR.cPCourse_please_choose}</option>
                                    {this.state.possibleLocations &&
                                        this.state.possibleLocations!.map((l: Location) => {
                                            return (
                                                <option key={l.ID} value={l.ID}>
                                                    {l.Name}
                                                </option>
                                            );
                                        })}
                                </Input>
                                <span className="fieldHint">{TR.cPCourse_location_help}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label htmlFor="VideoURL" className={this.errorClass('VideoURL')}>
                                    {TR.cPCourse_video}
                                </Label>
                                <Input
                                    type="text"
                                    id="VideoURL"
                                    onChange={this.inputHandler}
                                    value={this.state.course.VideoURL}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CPCourseBaseData
                        baseDataName={'Kategorien'}
                        baseDataKey={'categories'}
                        courseBaseDataArray={this.state.course.Categories}
                        onChangeHandler={this.baseDataOnChange}
                    />
                    <CPCourseBaseData
                        baseDataName={'Level'}
                        baseDataKey={'levels'}
                        courseBaseDataArray={this.state.course.Levels}
                        onChangeHandler={this.baseDataOnChange}
                    />
                    <CPCourseBaseData
                        baseDataName={'Techniken'}
                        baseDataKey={'techniques'}
                        courseBaseDataArray={this.state.course.Techniques}
                        onChangeHandler={this.baseDataOnChange}
                    />
                    <CPCourseBaseData
                        baseDataName={'Themenfelder'}
                        baseDataKey={'topics'}
                        courseBaseDataArray={this.state.course.Topics}
                        onChangeHandler={this.baseDataOnChange}
                    />
                    <Label htmlFor="CPCourseBaseDataTags" className={this.errorClass('CPCourseBaseDataTags')}>
                        {TR.cPCourse_keywords}
                    </Label>
                    <CPCourseBaseDataTags
                        id="CPCourseBaseDataTags"
                        courseBaseDataArray={this.state.course.Tags}
                        onChangeHandler={this.baseDataOnChange}
                    />

                    <Row className={'mt-5'}>
                        <Col>{this.renderMultiImageUpload()}</Col>
                    </Row>
                    <Row className={'mt-5'}>
                        <Col md={6}>{this.renderBookingOptions()}</Col>
                    </Row>
                    {this.state.course.Type === 'new' && (
                        <>
                            <Row className={'mt-4'}>
                                <Col md="12">
                                    <h3>{TR.cPCourse_choose_coursetype}</h3>
                                </Col>
                                <Col md="4">
                                    <p className={'course-choice'}>
                                        <a onClick={() => this.setCourseChoiceType('single')}>
                                            <FAIcon
                                                icon={
                                                    this.state.courseTypeChoice === 'single'
                                                        ? 'check-circle-o'
                                                        : 'circle-o'
                                                }
                                                className={'fa-large'}
                                            />
                                            <strong>{TR.cPCourse_individual}</strong> {TR.cPCourse_individual_help}
                                        </a>
                                    </p>
                                </Col>
                                <Col md="4">
                                    <p className={'course-choice'}>
                                        <a onClick={() => this.setCourseChoiceType('continuous')}>
                                            <FAIcon
                                                icon={
                                                    this.state.courseTypeChoice === 'continuous'
                                                        ? 'check-circle-o'
                                                        : 'circle-o'
                                                }
                                                className={'fa-large'}
                                            />
                                            <strong>{TR.cPCourse_continuous2}</strong> {TR.cPCourse_continuous_help}
                                        </a>
                                    </p>
                                </Col>
                                <Col md="4">
                                    <p className={'course-choice'}>
                                        <a onClick={() => this.setCourseChoiceType('set')}>
                                            <FAIcon
                                                icon={
                                                    this.state.courseTypeChoice === 'set'
                                                        ? 'check-circle-o'
                                                        : 'circle-o'
                                                }
                                                className={'fa-large'}
                                            />
                                            <strong>{TR.cPCourse_sets}:</strong> {TR.cPCourse_sets_help}
                                        </a>
                                    </p>
                                </Col>
                                <Col md="4">
                                    <p className={'course-choice'}>
                                        <a onClick={() => this.setCourseChoiceType('ondemand')}>
                                            <FAIcon
                                                icon={
                                                    this.state.courseTypeChoice === 'ondemand'
                                                        ? 'check-circle-o'
                                                        : 'circle-o'
                                                }
                                                className={'fa-large'}
                                            />
                                            <strong>{TR.cPCourse_on_demand}:</strong> {TR.cPCourse_on_demand_help}
                                        </a>
                                    </p>
                                </Col>
                                <Col md="4">
                                    <p className={'course-choice'}>
                                        <a onClick={() => this.setCourseChoiceType('selflearn')}>
                                            <FAIcon
                                                icon={
                                                    this.state.courseTypeChoice === 'selflearn'
                                                        ? 'check-circle-o'
                                                        : 'circle-o'
                                                }
                                                className={'fa-large'}
                                            />
                                            <strong>{TR.cPCourse_self_learn2}:</strong> {TR.cPCourse_self_learn_help}
                                        </a>
                                    </p>
                                </Col>
                            </Row>
                            <Row className={'mt-4'}>
                                <Col md="12">
                                    <Button onClick={this.commitCourseType}>{TR.cPCourse_choose_type}</Button>
                                </Col>
                            </Row>
                        </>
                    )}
                    {this.state.course.Type !== 'new' && (
                        <Row className={'mt-5'}>
                            <Col md="12">
                                <h3>
                                    {TR.cPCourse_type}: {translations[this.state.course.Type]}
                                </h3>
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <Col md={12}>
                            {(ctype === 'single' || courseTypeChoice === 'single') && this.renderAppointmentSingle()}
                            {(ctype === 'set' || courseTypeChoice === 'set') && this.renderAppointmentSet()}
                            {(ctype === 'continuous' || courseTypeChoice === 'continuous') &&
                                this.renderAppointmentContinuous()}
                        </Col>
                    </Row>
                    <Row id="publishCourseArea">
                        <Col className="mt-4">
                            <hr />
                            <h3>Kurs veröffentlichen</h3>{' '}
                            {!anyProblems && (
                                <>
                                    <FormGroup check={true}>
                                        <Label check={true}>
                                            <Input
                                                type="radio"
                                                name="published"
                                                value="false"
                                                onChange={this.coursePublishedOnChange}
                                                checked={!this.state.course.Published}
                                                className="mr-4"
                                            />
                                            {TR.cPCourse_offline}
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true}>
                                        <Label check={true}>
                                            <Input
                                                type="radio"
                                                name="published"
                                                value="true"
                                                onChange={this.coursePublishedOnChange}
                                                checked={this.state.course.Published}
                                                className="mr-4"
                                            />
                                            {TR.cPCourse_online}
                                        </Label>
                                    </FormGroup>
                                    {this.state.course.PublicUrl &&
                                        this.state.course.Published &&
                                        (this.state.course.NeedsSync === undefined ||
                                            this.state.course.NeedsSync === false) &&
                                        this.state.course.SyncError === '' && (
                                            <>
                                                <h5 className="mt-4">{TR.cPCourse_link_to_course}</h5>
                                                <a target="_blank" href={this.state.course.PublicUrl}>
                                                    {this.state.course.PublicUrl}
                                                </a>
                                            </>
                                        )}
                                    {this.state.course.Published &&
                                        this.state.originalPublished &&
                                        (this.state.course.NeedsSync || !this.state.course.PublicUrl) &&
                                        this.state.course.SyncError === '' && (
                                            <>
                                                <h5 className="mt-4">{TR.cPCourse_link_to_course}</h5>
                                                <p>{TR.cPCourse_in_publishing}</p>
                                            </>
                                        )}
                                    {this.state.course.Published &&
                                        !this.state.originalPublished &&
                                        (this.state.course.NeedsSync || !this.state.course.PublicUrl) &&
                                        this.state.course.SyncError === '' && (
                                            <>
                                                <h5 className="mt-4">{TR.cPCourse_link_to_course}</h5>
                                                <p>{TR.cPCourse_save_now}</p>
                                            </>
                                        )}
                                    {this.state.course.Published &&
                                        this.state.course.SyncError &&
                                        this.state.course.SyncError !== '' && (
                                            <>
                                                <h5 className="mt-4">{TR.cPCourse_link_to_course}</h5>
                                                <p>{TR.cPCourse_could_not_update}</p>
                                            </>
                                        )}
                                </>
                            )}
                            {anyProblems && (
                                <>
                                    <Alert color="danger" className="cpitemwarning" style={{ float: 'none' }}>
                                        <FAIcon icon="exclamation-triangle" />
                                        <span>
                                            <strong>{TR.cPCourse_can_save}</strong>, {TR.cPCourse_but_not_publish}
                                            <br />
                                        </span>
                                        {!titleOk && (
                                            <span>
                                                - {TR.cPCourse_add_title}
                                                <br />
                                            </span>
                                        )}
                                        {!descriptionOk && (
                                            <span>
                                                - {TR.cPCourse_add_description}
                                                <br />
                                            </span>
                                        )}
                                        {!videoURLOk && (
                                            <span>
                                                - {TR.cPCourse_add_video}
                                                <br />
                                            </span>
                                        )}
                                        {!timesOk && (
                                            <span>
                                                - {TR.cPCourse_course_times}
                                                <br />
                                            </span>
                                        )}
                                        {!appointmentsOk && (
                                            <span>
                                                - {TR.cPCourse_add_appointments}
                                                <br />
                                            </span>
                                        )}
                                        {!bookingOptionsOk && (
                                            <span>
                                                - {TR.cPCourse_add_option}
                                                <br />
                                            </span>
                                        )}
                                        {!lecturerOK && (
                                            <span>
                                                - {TR.cPCourse_add_lecturer}
                                                <br />
                                            </span>
                                        )}
                                        {!locationOK && (
                                            <span>
                                                - {TR.cPCourse_add_location}
                                                <br />
                                            </span>
                                        )}
                                        {!categoryOk && (
                                            <span>
                                                - {TR.cPCourse_add_category}
                                                <br />
                                            </span>
                                        )}
                                        {!levelsOk && (
                                            <span>
                                                - {TR.cPCourse_add_level}
                                                <br />
                                            </span>
                                        )}
                                        {!techniquesOk && (
                                            <span>
                                                - {TR.cPCourse_add_technique}
                                                <br />
                                            </span>
                                        )}
                                        {!topicsOk && (
                                            <span>
                                                - {TR.cPCourse_add_topic}
                                                <br />
                                            </span>
                                        )}
                                    </Alert>
                                    <hr />
                                </>
                            )}
                        </Col>
                    </Row>
                    {this.state.showCalendar && (
                        <Calendar
                            selected={this.state.calendarSelected}
                            onCancel={this.calendarCancel}
                            onAccept={this.calendarAccept}
                        />
                    )}
                </Container>
                <div
                    style={{
                        height: 55,
                        backgroundColor: 'white',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        position: 'fixed',
                        borderTop: '1px solid #ddd',
                        padding: 10,
                        zIndex: 2,
                        textAlign: 'center',
                    }}
                >
                    <Button onClick={this.save}>{TR.cPCourse_save}</Button>
                    {!anyProblems && (
                        <Button style={{ marginLeft: 20 }} onClick={this.saveAndPublish}>
                            {TR.cPCourse_save_and_publish}
                        </Button>
                    )}
                    {anyProblems && (
                        <a style={{ marginLeft: 20 }} href="javascript:window.scrollTo(0, document.body.scrollHeight)">
                            {TR.cPCourse_publish}
                        </a>
                    )}
                </div>
                <Footer />
            </NetworkOverlay>
        );
    }

    public renderBookingOptions = () => {
        if (this.state.course) {
            return (
                <div>
                    <Modal isOpen={this.state.modalDuplicateOpen}>
                        <ModalHeader>{TR.cPCourse_save_changes}</ModalHeader>
                        <ModalBody>{TR.cPCourse_confirm_duplicate}</ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.toogleModalDuplicate}>
                                {TR.cPCourse_cancel}
                            </Button>
                            <Button color="primary" onClick={this.saveAndDuplicate}>
                                {TR.cPCourse_continue}
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.modalDeleteOpen}>
                        <ModalHeader>{TR.cPCourse_delete}</ModalHeader>
                        <ModalBody>{TR.cPCourse_are_you_sure}</ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.toggleModalDelete}>
                                {TR.cPCourse_cancel}
                            </Button>
                            <Button color="primary" onClick={this.deleteCourse}>
                                {TR.cPCourse_yes_delete}
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.modalCannotDeleteOpen}>
                        <ModalHeader>{TR.cPCourse_bookings}</ModalHeader>
                        <ModalBody>{TR.cPCourse_cannot_delete}</ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.closeModalCannotDelete}>
                                {TR.cPCourse_ok}
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <h3>Buchungsoptionen</h3>
                    {this.state.course.BookingOptions.map((bo: BookingOption, i: number) => {
                        return (
                            <Row key={i} className={'mb-2'}>
                                <Col md="6">
                                    <Input
                                        type="text"
                                        value={bo.Name}
                                        disabled={bo.Default}
                                        onChange={(e: any) => this.changeBookingOptionValue(i, 'name', e.target.value)}
                                    />
                                </Col>
                                <Col md="6" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Input
                                        type="number"
                                        maxLength={8}
                                        style={{ width: '100px', textAlign: 'right' }}
                                        value={bo.Price}
                                        onChange={(e: any) => this.changeBookingOptionValue(i, 'price', e.target.value)}
                                    />
                                    &nbsp;€
                                    {!bo.Default && (
                                        <a className="iconButton" onClick={() => this.removeBookingOption(i)}>
                                            <FAIcon icon="trash" className="ml-4" />
                                        </a>
                                    )}
                                </Col>
                            </Row>
                        );
                    })}
                    <Row>
                        <Col>
                            <Button className={'mt-3'} onClick={this.addBookingOption}>
                                {TR.cPCourse_new_option}
                            </Button>
                        </Col>
                    </Row>
                </div>
            );
        }
        return null;
    };

    public renderMultiImageUpload = () => {
        if (this.state.course) {
            return (
                <div>
                    <h3>{TR.cPCourse_images}</h3>
                    <Row>
                        <ImageChooserMultiple
                            images={this.state.course.Images}
                            uploadImages={this.state.uploadImages}
                            onFileChosen={this.addUploadImage}
                            onDeleteImage={this.deleteImageHandler}
                            onDeleteUploadImage={this.deleteUploadImage}
                            placeHolderText={TR.cPLocationComponent_upload_images}
                        />
                    </Row>
                </div>
            );
        }
        return null;
    };

    public renderAppointmentSingle = () => {
        let list = null;
        if (this.state.course) {
            const ap = this.state.course.Appointments;
            list = ap.map((a: Appointment, i: number) => {
                const duration = moment(a.EndDate).diff(moment(a.StartDate), 'days') + 1;
                if (moment(a.StartDate).isAfter(moment())) {
                    return (
                        <tr key={i}>
                            <td>
                                <DatePicker
                                    selected={moment(a.StartDate)}
                                    minDate={moment().add(1, 'day')}
                                    onChange={(e: moment.Moment) => {
                                        this.changeAppointmentDateValue(i, 'startDate', e);
                                    }}
                                />
                            </td>
                            <td>
                                <DatePicker
                                    selected={moment(a.EndDate)}
                                    minDate={moment(a.StartDate)}
                                    onChange={(e: moment.Moment) => {
                                        this.changeAppointmentDateValue(i, 'endDate', e);
                                    }}
                                />
                            </td>
                            <td>{duration > 1 ? duration + ' Tage' : duration + ' Tag'}</td>
                            <td>
                                <Input
                                    type="text"
                                    style={{ width: '60px', display: 'inline-block' }}
                                    value={a.MaxParticipants}
                                    onChange={(e: any) => {
                                        this.changeAppointmentMaxParticipants(i, e.target.value);
                                    }}
                                />
                            </td>
                            <td>
                                <a className="iconButton" onClick={() => this.removeAppointment(i)}>
                                    <FAIcon icon="trash" className="ml-4" />
                                </a>
                            </td>
                        </tr>
                    );
                } else {
                    return (
                        <tr key={i}>
                            <td>{moment(a.StartDate).format('DD.MM.YYYY')}</td>
                            <td>{moment(a.EndDate).format('DD.MM.YYYY')}</td>
                            <td>{duration > 1 ? duration + ' Tage' : duration + ' Tag'}</td>
                            <td>{a.MaxParticipants}</td>
                            <td />
                        </tr>
                    );
                }
            });
        }
        return (
            <div>
                <Row className="mb-2 mt-4">
                    <Col>
                        <Table>
                            <thead>
                                <tr>
                                    <td>{TR.cPCourse_start_date}</td>
                                    <td>{TR.cPCourse_end_date}</td>
                                    <td>{TR.cPCourse_duration}</td>
                                    <td>{TR.cPCourse_number_seats}</td>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>{list}</tbody>
                        </Table>
                    </Col>
                </Row>
                {this.state.course && this.state.course.Type === 'single' && (
                    <Row>
                        <Col>
                            <Button onClick={this.addSingleAppointment}>{TR.cPCourse_new_appointment}</Button>
                        </Col>
                    </Row>
                )}
            </div>
        );
    };

    public renderAppointmentContinuous = () => {
        let list = null;
        if (this.state.course) {
            const ap = this.state.course.Appointments;
            list = ap.map((a: Appointment, i: number) => {
                if (moment(a.StartDate).isAfter(moment())) {
                    return (
                        <tr key={i}>
                            <td>
                                <DatePicker
                                    selected={moment(a.StartDate)}
                                    minDate={moment().add(1, 'day')}
                                    onChange={(e: moment.Moment) => {
                                        this.changeAppointmentDateValue(i, 'startDate', e);
                                    }}
                                />
                            </td>
                            <td>
                                {moment(this.state.course!.StartTime).format('HH:mm')}-
                                {moment(this.state.course!.EndTime).format('HH:mm')}
                            </td>
                            <td>
                                <Input
                                    type="text"
                                    style={{ width: '60px', display: 'inline-block' }}
                                    value={a.MaxParticipants}
                                    onChange={(e: any) => {
                                        this.changeAppointmentMaxParticipants(i, e.target.value);
                                    }}
                                />
                            </td>
                            <td>
                                <a className="iconButton" onClick={() => this.removeAppointment(i)}>
                                    <FAIcon icon="trash" className="ml-4" />
                                </a>
                            </td>
                        </tr>
                    );
                } else {
                    return (
                        <tr key={i}>
                            <td>{moment(a.StartDate).format('DD.MM.YYYY')}</td>
                            <td>-</td>
                            <td>{a.MaxParticipants}</td>
                            <td />
                        </tr>
                    );
                }
            });
        }
        return (
            <div>
                {this.state.course && this.state.course.Type === 'continuous' && (
                    <Row className="mb-2 mt-2">
                        <Col md="2">
                            {TR.cPCourse_start_time}:{' '}
                            <DatePicker
                                selected={moment(this.state.course.StartTime)}
                                onChange={(e: moment.Moment) => {
                                    this.changeDateTimeValue('StartTime', e);
                                }}
                                showTimeSelect={true}
                                showTimeSelectOnly={true}
                                timeIntervals={15}
                                dateFormat="HH:mm"
                                timeFormat="HH:mm"
                                timeCaption="Zeit"
                                minTime={moment('2019-30-01 00:00:00')}
                                maxTime={moment(this.state.course.EndTime)}
                            />
                        </Col>
                        <Col md="2">
                            {TR.cPCourse_end_time}:{' '}
                            <DatePicker
                                selected={moment(this.state.course.EndTime)}
                                onChange={(e: moment.Moment) => {
                                    this.changeDateTimeValue('EndTime', e);
                                }}
                                showTimeSelect={true}
                                showTimeSelectOnly={true}
                                timeIntervals={15}
                                dateFormat="HH:mm"
                                timeFormat="HH:mm"
                                timeCaption="Zeit"
                                minTime={moment(this.state.course.StartTime)}
                                maxTime={moment(this.state.course.EndTime).set('hour', 23).set('minute', 59)}
                            />
                        </Col>
                    </Row>
                )}
                <Row className="mb-2 mt-4">
                    <Col>
                        <Table>
                            <thead>
                                <tr>
                                    <td>Datum</td>
                                    <td>Uhrzeit</td>
                                    <td>Plätze zur Vermittlung</td>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>{list}</tbody>
                        </Table>
                    </Col>
                </Row>
                {this.state.course && this.state.course.Type === 'continuous' && (
                    <Row>
                        <Col>
                            <div className="w-100 d-flex flex-row">
                                <label className="my-auto">{TR.cPCourse_pre_seats} </label>
                                <Input
                                    className="ml-3"
                                    value={this.state.defaultParticipants}
                                    onChange={this.changeDefaultParticipants}
                                    style={{ width: '60px' }}
                                />
                                <Button className="ml-3" onClick={this.openCalendarForContinuous}>
                                    {TR.cPCourse_add_appointments2}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                )}
            </div>
        );
    };

    public renderAppointmentSet = () => {
        let list = null;
        if (this.state.course) {
            const ap = this.state.course.Appointments;
            list = ap.map((a: Appointment, i: number) => {
                const isOver = moment().isAfter(moment(a.StartDate));
                if (!isOver) {
                    return (
                        <tr key={i}>
                            <td>{moment(a.StartDate).format('DD.MM.YYYY')}</td>
                            <td>
                                {a.Dates &&
                                    a.Dates.sort((dateA: Date, dateB: Date) => {
                                        return moment(dateA).isBefore(dateB) ? -1 : 1;
                                    }).map((date: Date) => {
                                        const fdate = moment(date).format('DD.MM.YYYY');
                                        return (
                                            <span key={fdate}>
                                                <div className="aDate">
                                                    {fdate}
                                                    <FAIcon
                                                        icon="trash"
                                                        onClick={() => {
                                                            this.removeDateFromAppointment(i, date);
                                                        }}
                                                        className="ml-1 float-none"
                                                    />
                                                </div>
                                            </span>
                                        );
                                    })}
                                <FAIcon
                                    icon="plus-circle"
                                    className="ml-1 float-none mr-3"
                                    onClick={() => this.openCalendarForSet(i, a.Dates)}
                                />
                            </td>
                            <td>{a.Dates ? a.Dates.length : '-'}</td>
                            <td>
                                <Input
                                    type="text"
                                    style={{ width: '60px', display: 'inline-block' }}
                                    value={a.MaxParticipants}
                                    onChange={(e: any) => {
                                        this.changeAppointmentMaxParticipants(i, e.target.value);
                                    }}
                                />
                            </td>
                            <td>
                                <a className="iconButton" onClick={() => this.removeAppointment(i)}>
                                    <FAIcon icon="trash" className="ml-4" />
                                </a>
                            </td>
                        </tr>
                    );
                } else {
                    return null;
                }
            });
        }
        return (
            <div>
                <Row className="mb-2 mt-4">
                    <Col>
                        <Table>
                            <thead>
                                <tr>
                                    <td>{TR.cPCourse_start_date}</td>
                                    <td>{TR.cPCourse_appointments}</td>
                                    <td>{TR.cPCourse_number}</td>
                                    <td>{TR.cPCourse_number_seats}</td>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>{list}</tbody>
                        </Table>
                    </Col>
                </Row>
                {this.state.course && this.state.course.Type === 'set' && (
                    <Row>
                        <Col>
                            <Button onClick={this.addSingleAppointment}>{TR.cPCourse_new_set}</Button>
                        </Col>
                    </Row>
                )}
            </div>
        );
    };

    private loadData = () => {
        if (this.state.courseID) {
            ApiCourseLoad({ ID: this.state.courseID }, (sr) => {
                if (sr.Data !== undefined) {
                    const d = sr.Data;
                    this.setState({
                        course: d,
                        courseOrigin: JSON.parse(JSON.stringify(d)),
                        courseTypeChoice: d.Type === 'new' ? 'single' : undefined,
                        serverResponse: sr,
                        loading: false,
                        originalPublished: d.Published,
                    });
                } else {
                    this.setState({
                        serverResponse: sr,
                        loading: false,
                    });
                }
            });
        }
    };

    private loadLecturersAndLocations = () => {
        ApiCourseProvidersLoadmine((cpsr: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => {
            if (cpsr.OK && cpsr.Data) {
                this.setState(
                    {
                        possibleLecturers: cpsr.Data!.CourseProviderEdit.Lecturers,
                        possibleLocations: cpsr.Data!.CourseProviderEdit.Locations,
                    },
                    this.loadData
                );
            } else {
                this.setState({
                    serverResponse: cpsr,
                    loading: false,
                });
            }
        });
    };

    private toogleModalDuplicate = () => {
        this.setState({ modalDuplicateOpen: !this.state.modalDuplicateOpen });
    };

    private toggleModalDelete = () => {
        this.setState({ modalDeleteOpen: !this.state.modalDeleteOpen });
    };

    private closeModalCannotDelete = () => {
        this.setState({ modalCannotDeleteOpen: false });
    };

    private hasEntryChanged = (changed: any, origin: any): boolean => {
        if (typeof changed !== 'object') {
            if (changed !== origin) {
                return true;
            }
        } else {
            if (this.hasObjectChanged(changed, origin)) {
                return true;
            }
        }

        return false;
    };

    private hasObjectChanged = (changed: any, origin: any): boolean => {
        if (Array.isArray(changed)) {
            if (changed.length !== origin.length) {
                return true;
            } else {
                for (let index = 0; index < changed.length; index++) {
                    if (
                        origin[index] === null ||
                        origin[index] === undefined ||
                        this.hasEntryChanged(changed[index], origin[index])
                    ) {
                        return true;
                    }
                }
            }
        } else {
            for (const key of Object.keys(changed)) {
                if (
                    origin[key] === null ||
                    origin[key] === undefined ||
                    this.hasEntryChanged(changed[key], origin[key])
                ) {
                    return true;
                }
            }
        }

        return false;
    };

    private hasCourseChanged = (): boolean => {
        const course = this.state.course;
        const courseOrigin = this.state.courseOrigin;

        if (course === undefined || courseOrigin === undefined) {
            return false;
        }

        return this.hasObjectChanged(course, courseOrigin);
    };

    private canDuplicate = () => {
        if (this.hasCourseChanged()) {
            this.toogleModalDuplicate();
        } else {
            this.setState({ loading: true }, this.duplicateCourse);
        }
    };

    private deleteCourse = () => {
        this.setState({ modalDeleteOpen: false });
        ApiCourseDelete({ ID: this.state.courseID }, (sr) => {
            if (sr.OK && sr.Data != null && !sr.Data!.HasBookings) {
                this.setState({ redirectToList: true });
            } else if (sr.OK && sr.Data != null && sr.Data!.HasBookings) {
                this.setState({ modalCannotDeleteOpen: true });
            } else {
                this.setState({
                    loading: false,
                    serverResponse: sr,
                });
            }
        });
    };

    private duplicateCourse = () => {
        ApiCourseDuplicate({ ID: this.state.courseID }, (sr) => {
            if (sr.OK) {
                this.setState({ redirectToList: true });
            } else {
                this.setState({
                    loading: false,
                    serverResponse: sr,
                });
            }
        });
    };

    private saveAndDuplicate = () => {
        this.setState({ loading: true, modalDuplicateOpen: false }, () => {
            if (this.state.course) {
                ApiCourseSave(
                    {
                        Course: this.state.course,
                        ID: this.state.courseID,
                    },
                    (sr) => {
                        this.duplicateCourse();
                    }
                );
            }
        });
    };

    private saveAndPublish = () => {
        if (this.state.course) {
            const c = this.state.course;
            c.Published = true;
            this.setState({ course: c }, this.save);
        }
    };

    private save = () => {
        this.setState({ loading: true, modalDuplicateOpen: false }, () => {
            if (this.state.course) {
                ApiCourseSave(
                    {
                        Course: this.state.course,
                        ID: this.state.courseID,
                        UploadImages: this.state.uploadImages,
                    },
                    (sr) => {
                        this.setState({ saved: true });
                    }
                );
            }
        });
    };

    private addBookingOption = () => {
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            courseEdited.BookingOptions.push({ Name: '', Price: 0, Default: false });
            this.setState({ course: courseEdited });
        }
    };

    private coursePublishedOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (this.state.course) {
            const c = this.state.course;
            c.Published = e.target.value === 'true';
            this.setState({ course: c });
        }
    };

    private baseDataOnChange = (n: number[], str: string) => {
        switch (str) {
            case 'categories':
                // @ts-ignore
                this.setState((prevState) => {
                    // @ts-ignore
                    return { ...prevState, course: Object.assign(prevState.course, { Categories: n }) };
                });
                break;
            case 'levels':
                // @ts-ignore
                this.setState((prevState) => {
                    // @ts-ignore
                    return { ...prevState, course: Object.assign(prevState.course, { Levels: n }) };
                });
                break;
            case 'techniques':
                // @ts-ignore
                this.setState((prevState) => {
                    // @ts-ignore
                    return { ...prevState, course: Object.assign(prevState.course, { Techniques: n }) };
                });
                break;
            case 'topics':
                // @ts-ignore
                this.setState((prevState) => {
                    // @ts-ignore
                    return { ...prevState, course: Object.assign(prevState.course, { Topics: n }) };
                });
                break;
            case 'tags':
                // @ts-ignore
                this.setState((prevState) => {
                    // @ts-ignore
                    return { ...prevState, course: Object.assign(prevState.course, { Tags: n }) };
                });
                break;
        }
    };

    private removeBookingOption = (i: number) => {
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            courseEdited.BookingOptions.splice(i, 1);
            this.setState({ course: courseEdited });
        }
    };

    private setCourseChoiceType = (type: string) => {
        this.setState((prevState: State) => {
            return { ...prevState, courseTypeChoice: type };
        });
    };

    private commitCourseType = () => {
        this.setState((prevState: State) => {
            if (prevState.courseTypeChoice) {
                const courseEdited = Object.assign({}, this.state.course);
                courseEdited.Type = prevState.courseTypeChoice;
                return { ...prevState, course: courseEdited, courseTypeChoice: undefined };
            } else {
                return prevState;
            }
        });
    };

    private addSingleAppointment = () => {
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            courseEdited.Appointments.push({
                Dates: [],
                EndDate: moment(moment().startOf('day')).add(1, 'day'),
                MaxParticipants: 1,
                StartDate: moment(moment().startOf('day')).add(1, 'day'),
            });
            this.setState({ course: courseEdited });
        }
    };

    private removeAppointment = (i: number) => {
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            courseEdited.Appointments.splice(i, 1);
            this.setState({ course: courseEdited });
        }
    };

    private removeDateFromAppointment = (i: number, date: object) => {
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            let dates = courseEdited.Appointments[i].Dates;
            dates = dates.filter((d: object) => !moment(date).isSame(moment(d), 'day'));
            courseEdited.Appointments[i].Dates = dates;
            courseEdited.Appointments[i].StartDate = this.getEarliestAppointment(courseEdited.Appointments[i]);
            courseEdited.Appointments[i].EndDate = this.getLatestAppointment(courseEdited.Appointments[i]);
            this.setState({ course: courseEdited });
        }
    };

    private changeAppointmentDateValue = (i: number, field: string, val: any) => {
        if (this.state.course && val !== null) {
            const courseEdited = Object.assign({}, this.state.course);
            const currentDate = moment();
            if (currentDate.isAfter(val)) {
                return;
            }
            if (field === 'startDate') {
                courseEdited.Appointments[i].StartDate = val;
                if (moment(courseEdited.Appointments[i].StartDate).isAfter(courseEdited.Appointments[i].EndDate)) {
                    courseEdited.Appointments[i].EndDate = val;
                }
            } else if (field === 'endDate') {
                if (val.isSameOrAfter(courseEdited.Appointments[i].StartDate)) {
                    courseEdited.Appointments[i].EndDate = val;
                }
            }
            this.setState({ course: courseEdited });
        }
    };

    private changeDateTimeValue = (field: string, val: any) => {
        if (this.state.course && val !== null) {
            const courseEdited = Object.assign({}, this.state.course);
            if (field === 'StartTime') {
                courseEdited.StartTime = val;
            } else if (field === 'EndTime') {
                courseEdited.EndTime = val;
            }
            this.setState({ course: courseEdited });
        }
    };

    private changeAppointmentMaxParticipants = (i: number, val: string) => {
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            courseEdited.Appointments[i].MaxParticipants = Number(val);
            this.setState({ course: courseEdited });
        }
    };

    private changeBookingOptionValue = (i: number, field: string, val: string) => {
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            if (field === 'name') {
                courseEdited.BookingOptions[i].Name = val;
            } else {
                val = val.replace(/([^0-9,.-])/g, '');
                val = val.replace(/([,])/g, '.');
                let value = Number(val);
                if (isNaN(value)) {
                    value = 0;
                }
                courseEdited.BookingOptions[i].Price = value;
            }
            this.setState({ course: courseEdited });
        }
    };

    private onSetAccept = (newDates: moment.Moment[]) => {
        let courseEdited = this.state.course;
        if (this.state.course && this.state.calendarIndex !== undefined) {
            courseEdited = Object.assign({}, this.state.course);
            const allDates = courseEdited.Appointments[this.state.calendarIndex].Dates;
            allDates.push(...newDates);
            courseEdited.Appointments[this.state.calendarIndex].Dates = allDates;
            courseEdited.Appointments[this.state.calendarIndex].StartDate = this.getEarliestAppointment(
                courseEdited.Appointments[this.state.calendarIndex]
            );
            courseEdited.Appointments[this.state.calendarIndex].EndDate = this.getLatestAppointment(
                courseEdited.Appointments[this.state.calendarIndex]
            );
        }
        this.setState({ course: courseEdited, showCalendar: false });
    };

    private onContinuousAccept = (newDates: moment.Moment[]) => {
        let courseEdited = this.state.course;
        if (this.state.course) {
            courseEdited = Object.assign({}, this.state.course);
            const appointments = courseEdited.Appointments;
            const newAppointments = newDates.map((d: moment.Moment) => ({
                Dates: [],
                EndDate: d,
                MaxParticipants: this.state.defaultParticipants,
                StartDate: d,
            }));
            appointments.push(...newAppointments);
            courseEdited.Appointments = appointments;
        }
        this.setState({ course: courseEdited, showCalendar: false });
    };

    private openCalendarForSet = (index: number, selected: object[]) => {
        this.setState({
            calendarIndex: index,
            calendarSelected: selected.map((d: object, i: number) => moment(d)),
            calendarType: 'set',
            showCalendar: true,
        });
    };

    private openCalendarForContinuous = () => {
        if (this.state.course) {
            const appointmentDates = this.state.course.Appointments.map((a: Appointment) => moment(a.StartDate));
            this.setState({ showCalendar: true, calendarSelected: appointmentDates, calendarType: 'continuous' });
        }
    };

    private calendarCancel = () => {
        this.setState({ showCalendar: false });
    };

    private calendarAccept = (newDates: moment.Moment[]) => {
        this.setState({ showCalendar: false });
        if (this.state.calendarType === 'continuous') {
            this.onContinuousAccept(newDates);
        } else if (this.state.calendarType === 'set') {
            this.onSetAccept(newDates);
        }
    };

    private changeDefaultParticipants = (e: React.FormEvent<HTMLInputElement>) => {
        let value = parseInt(e.currentTarget.value, 10);

        if (isNaN(value)) {
            value = 0;
        }

        this.setState({ defaultParticipants: value });
    };

    private inputHandler = (e: any) => {
        this.setState({ serverResponse: undefined });
        if (this.state.course) {
            const courseEdited = Object.assign({}, this.state.course);
            // @ts-ignore
            courseEdited[e.target.id] = e.target.value;
            this.setState({ course: courseEdited });
        }
    };

    private errorClass = (fieldname: string) => {
        if (this.state.serverResponse && this.state.serverResponse.Errors) {
            const errorsForThisField = this.state.serverResponse.Errors.filter(
                (error: ValidationError) => error.Parameter.toLowerCase() === fieldname.toLowerCase()
            );
            return errorsForThisField.length > 0 ? 'error' : '';
        }
        return '';
    };

    private getEarliestAppointment = (appointment: Appointment) => {
        if (appointment.Dates.length > 0) {
            const sortedAppointments = appointment.Dates.sort((dateA: Date, dateB: Date) => {
                return moment(dateA).isBefore(dateB) ? -1 : 1;
            });
            return sortedAppointments[0];
        } else {
            return moment().startOf('day').add(1, 'day');
        }
    };

    private getLatestAppointment = (appointment: Appointment) => {
        if (appointment.Dates.length > 0) {
            const sortedAppointments = appointment.Dates.sort((dateA: Date, dateB: Date) => {
                return moment(dateA).isBefore(dateB) ? 1 : -1;
            });
            return sortedAppointments[0];
        } else {
            return moment().startOf('day').add(1, 'day');
        }
    };

    private getLecturerName = (id: number) => {
        let lecturers: Lecturer[] = [];
        if (this.state.possibleLecturers) {
            if (this.state.possibleLecturers!.length > 0) {
                lecturers = this.state.possibleLecturers!.filter((l: Lecturer) => {
                    return l.ID === id;
                });
            }
        }
        if (lecturers.length > 0) {
            return lecturers[0].FirstName + ' ' + lecturers[0].LastName;
        } else {
            return '';
        }
    };

    private changeLecturer = (lecturerID: number) => {
        const courseEdited = { ...this.state.course! };
        courseEdited.LecturerID = lecturerID;
        courseEdited.LecturerName = this.getLecturerName(lecturerID);
        this.setState((prevState: State): State => {
            return { ...prevState, course: courseEdited };
        });
    };

    private changeLocation = (locationID: number) => {
        const courseEdited = { ...this.state.course! };
        courseEdited.LocationID = locationID;
        this.setState((prevState: State): State => {
            return { ...prevState, course: courseEdited };
        });
    };

    private addUploadImage = (image: UploadImage) => {
        this.setState({ uploadImages: [...this.state.uploadImages, image] });
    };

    private deleteUploadImage = (index: number) => {
        const uploadImages = this.state.uploadImages;
        uploadImages.splice(index, 1);
        this.setState({ uploadImages: [...uploadImages] });
    };

    private deleteImageHandler = (index: number) => {
        const course = { ...this.state.course! };
        const images: Image[] = [...course.Images];
        const image = images.splice(index, 1);
        course.Images = images;

        this.setState({
            course,
            uploadImages: [
                ...this.state.uploadImages,
                {
                    Delete: true,
                    FileName: '',
                    ImageData: '',
                    ID: image[0].ID,
                },
            ],
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/cpCourse/CPCourse.tsx